import Vue from "vue";
// 存储老师请假时段
interface IState {
  leaveType: string | number;
  leaveList: any;
  leaveReason: string;
  fileList: string[];
}
export default {
  namespaced: true,
  state(): IState {
    return {
      leaveType: 1,
      leaveList: [],
      leaveReason: "",
      fileList: []
    };
  },
  mutations: {
    // 设置请假类型
    setLeaveType(state: IState, type: string | number) {
      state.leaveType = type;
    },
    // 设置请假时间
    setLeaveList(state: IState, list: any) {
      state.leaveList = list;
    },
    // 设置请假原因
    setLeaveReason(state: IState, text: string) {
      state.leaveReason = text;
    },
    // 设置证明文件
    setFileList(state: IState, list: string[]) {
      state.fileList = list;
    }
  },
  getters: {
    getLeaveInfo(state: IState) {
      return state;
    },
    getFileList(state: IState) {
      return state.fileList;
    }
  }
};
